module.exports = "/_next/static/images/tennisIcon@3x-864dcaca3cd972ee88348922e331b933.png";